<template>
  <div class="fill-height" v-if="employeeSalaryReport">
    <div class="grid">
      <div class="border pa-5 d-flex flex-wrap">
        <BaseInput
          :label="localStorage.translations.pages['planning_orders'].table['proekt']"
          type="autocomplete"
          v-model="data.project"
          :items="projectList"
          placeholder="—"
          multiple
          minimize
          small-chips
          @change="getData"
        />
        <BaseInput
          :label="localStorage.translations.pages.finance['period-table'].employee"
          type="autocomplete"
          v-model="data.user"
          :items="userList"
          placeholder="—"
          multiple
          minimize
          small-chips
          @change="getData"
        />
      </div>
      <div>
        <div
          v-for="(employee, e) in employeeSalaryReport.employees"
          :key="'employee' + e"
          class="horizontalScroll"
        >
          <FinanceSalarySliceShowEmployee
            :data="employee"
            :id="e"
            :check-edit-access="checkEditAccess"
            :on-update="onUpdate"
            :ref="'employee' + e"
            :collection="collection"
            :period="period"
            :responsible-show="projectList.length > 0 && projectList[0].responsible.length > 0"
          />
        </div>
        <FinanceSalarySliceShowTable v-if="projectList.length > 0 && projectList[0].responsible.length > 0" total-responsible class="horizontalScroll">
          <div slot="title" class="pb-5 subtitle">
            {{ localStorage.translations.pages['sales_project']['planned_resources-responsible_employees'].main }}
          </div>
          <FinanceSalarySliceShowTableHeader total-responsible />
          <FinanceSalarySliceShowTableTotal total-responsible
            v-for="(resp, r) in projectList"
            :key="r + '_responsible'"
            :responsible="resp"
          />
        </FinanceSalarySliceShowTable>
      </div>
    </div>
    <div class="fixedBtn">
      <FinanceSalarySliceShowPdf
        :key="key"
        :employees="employees"
        :disabled="changedData"
        :period="period"
        :responsible="projectList"
        :responsible-show-total="projectList.length > 0 && projectList[0].responsible.length > 0"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import FinanceSalarySliceShowTable from 'components/finance/salary/show/FinanceSalarySliceShowTable'
import FinanceSalarySliceShowTableHeader from 'components/finance/salary/show/FinanceSalarySliceShowTableHeader'
import FinanceSalarySliceShowTableTotal from 'components/finance/salary/show/FinanceSalarySliceShowTableTotal'
import BaseCheckbox from 'components/base/BaseCheckbox'
import FinanceSalarySliceShowTableByDays from 'components/finance/salary/show/FinanceSalarySliceShowTableByDays'
import BaseInput from 'components/base/BaseInput'
import Plug from 'components/Plug'
import FinanceSalarySliceShowEmployee from 'components/finance/salary/FinanceSalarySliceShowEmployee'
import FinanceSalarySliceShowPdf from 'components/finance/salary/show/FinanceSalarySliceShowPdf'

export default {
  name: 'salaryListShow',
  components: {
    FinanceSalarySliceShowTable,
    FinanceSalarySliceShowTableHeader,
    FinanceSalarySliceShowTableTotal,
    FinanceSalarySliceShowPdf,
    FinanceSalarySliceShowEmployee,
  },
  data: () => ({
    key: 0,
    data: {
      dates: [],
      project: [],
      user: [],
    },
  }),
  computed: {
    ...mapGetters('employeeSalaryReport', ['employeeSalaryReport']),
    userList() {
      let result = []
      if (this.employeeSalaryReport && this.employeeSalaryReport.employees)
        for (let i in this.employeeSalaryReport.employees)
          result.push({
            id: i,
            name:
              this.employeeSalaryReport.employees[i].first_name +
              ' ' +
              this.employeeSalaryReport.employees[i].last_name,
          })
      return result
    },
    projectList() {
      let result = []
      if (this.employeeSalaryReport && this.employeeSalaryReport.projects)
        for (let i in this.employeeSalaryReport.projects)
          result.push({
            id: i,
            name: this.employeeSalaryReport.projects[i].name,
            responsible: this.employeeSalaryReport.projects[i].responsible ? Object.values(this.employeeSalaryReport.projects[i].responsible) : [],
          })
      return result
    },
    collection() {
      let result = {
        current: { employees: {} },
        previous: { employees: {} },
      }
      let name = 'current'
      if (this?.employeeSalaryReport?.employees)
        for (let e in this.employeeSalaryReport.employees) {
          let projects = this.employeeSalaryReport.employees[e].projects
          for (let p in projects) {
            let arr = ['work_types', 'extras']
            for (let a in arr) {
              let type = arr[a]
              if (projects[p][type]) {
                let works = projects[p][type]
                for (let w in works) {
                  let days = works[w].days
                  for (let d in days) {
                    name = d < this.data.dates[0] ? 'previous' : 'current'
                    if (!result[name].employees[e]) result[name].employees[e] = { projects: {} }
                    if (!result[name].employees[e].projects[p])
                      result[name].employees[e].projects[p] = { name: projects[p].name }
                    if (!result[name].employees[e].projects[p][type])
                      result[name].employees[e].projects[p][type] = {}
                    if (!result[name].employees[e].projects[p][type][w]) {
                      result[name].employees[e].projects[p][type][w] = {
                        is_hourly: works[w].is_hourly,
                        measure: works[w].measure,
                        name: works[w].name,
                        salary: works[w].salary,
                      }
                      result[name].employees[e].projects[p][type][w].days = {}
                    }
                    if (!result[name].employees[e].projects[p][type][w].days[d])
                      result[name].employees[e].projects[p][type][w].days[d] = days[d]
                  }
                }
              }
            }
          }
        }
      return result
    },
    checkEditAccess() {
      return this.$userCheckAccess({
        abilities: 'edit_salary',
      })
    },
    employees() {
      let result = []
      if (this?.employeeSalaryReport?.employees) {
        for (let i in this.employeeSalaryReport.employees) {
          if (this.$refs['employee' + i]) {
            result.push(this.$refs['employee' + i][0].employee)
          }
        }
      }
      return result
    },
    changedData() {
      let result = [false]
      if (this.employeeSalaryReport && this.employeeSalaryReport.employees)
        for (let e in this.employeeSalaryReport.employees)
          if (this.$refs['employee' + e]) {
            let temp = this.$refs['employee' + e][0].changedData
            result = result.concat(Object.values(temp).map((d) => d.changedData))
          }
      return !result.every((e) => {
        return !e
      })
    },
    period() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.key++
      let s = this.employeeSalaryReport['start_day']
        ? this.employeeSalaryReport['start_day'].split('-')
        : []
      let e = this.employeeSalaryReport['end_day']
        ? this.employeeSalaryReport['end_day'].split('-')
        : []
      return {
        term: s.length ? s.join('.') + ' - ' + e.join('.') : '',
        start: s.length ? s[2] + '-' + s[1] + '-' + s[0] : '',
        end: e.length ? e[2] + '-' + e[1] + '-' + e[0] : '',
      }
    },
  },
  created() {
    this.onEmployeeSalaryReport({ id: this.$route.params.id })
  },
  beforeDestroy() {
    this.setEmployeeSalaryReport({})
  },
  methods: {
    ...mapActions('employeeSalaryReport', ['onEmployeeSalaryReport']),
    ...mapActions('workClientProjectsPeriodReportUpdate', [
      'onWorkClientProjectsPeriodReportUpdate',
    ]),
    ...mapMutations('employeeSalaryReport', ['setEmployeeSalaryReport']),

    async getData() {
      await this.onEmployeeSalaryReport({
        id: this.$route.params.id,
        project: this.data.project.join(','),
        user: this.data.user.join(','),
      }).then(() => {
        this.key++
      })
    },

    async onUpdate(data, switchValue, extra, responsible) {
      if (data && data.length > 0) {
        this.loadingAnimationFullPage = true
        await this.onWorkClientProjectsPeriodReportUpdate({
          id: this.$route.params.id,
          data: responsible ? data.map(i => i.id) : data,
          paid: true,
          responsible: responsible,
          extra: extra,
        }).then(() => {
          this.getData()
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-row-gap: 30px;
}

.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}

.horizontalScroll {
  @media #{map-get($display-breakpoints, 'lg-and-down')} {
    overflow-x: scroll;
    max-width: 93vw;
  }
}

:deep() .subtitle {
  color: #277faf;
  font-weight: bolder;
}

.border {
  border: 1px solid #bdbdbd;
  border-radius: 10px;
}
</style>